/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (min-width:992px){.post-details[_ngcontent-%COMP%]{overflow-y:auto}}@media (max-width:991.98px){.post-details[_ngcontent-%COMP%]{padding-left:0;padding-right:0}}"];
export { styles as styles };
